<template>
  <ThePage :title="i18n(translations.title)">
    <template #pageTitle>
      {{ i18n(translations.title) }}
    </template>
    <template #pageContent>
      <NavTabs
        :index-route-name="ROUTE_NAMES.PROFILE.INDEX"
        :label="translations.navigation"
        :should-show-label
      />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { ROUTE_NAMES } from '~/constants/routes'
import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import translations from './Profile.translations'

const i18n = useI18n()
const { isAdmin } = useSellerInfoStore()

function shouldShowLabel(routeName: string) {
  const adminProtectedRoutes = [ROUTE_NAMES.PROFILE.USER_PERMISSIONS]

  return isAdmin || !adminProtectedRoutes.includes(routeName)
}
</script>
